(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-vx-measurements]');
  if (!button) return;
  const section = button.closest('.shopify-section');
  const details = section?.querySelector('.vexllo-product-details details');
  if (!details) return;
  details.open = true;
  const target = details.querySelector('table') || details;
  target.setAttribute('tabindex', '-1');
  target.focus({preventScroll:true});
  target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
});
  } catch(e) { console.error(e); }
})();

})();
